// extracted by mini-css-extract-plugin
module.exports = {"noTitle":"index_noTitle__31FGu","withOutPadding":"index_withOutPadding__30Yjb"};